import { FC } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Clock, Settings } from "lucide-react"
import { DeviceDTOStatusEnum } from "@/gen/api"
import type { DeviceDetailDTO } from "@/gen/api"
import DeviceStatus from "./DeviceStatus"
import { TableDateDisplay } from "./ui/date-display"

interface DeviceInformationProps {
  device: DeviceDetailDTO
}

const DeviceInformation: FC<DeviceInformationProps> = ({ device }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="size-5" />
          Device Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold">{device.name}</h3>
          <DeviceStatus status={device.status as DeviceDTOStatusEnum} />
        </div>

        <div className="grid grid-cols-1 gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-muted rounded-lg">
              <Settings className="size-4" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Serial Number</p>
              <p className="font-medium">{device.serialNumber}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="p-2 bg-muted rounded-lg">
              <Clock className="size-4" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Last Updated</p>
              <p className="font-medium">
                <TableDateDisplay date={device.lastUpdated ?? null} />
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default DeviceInformation
